module.exports = __webpack_public_path__ + "static/a_sea_of_split_peas-ad0c8c2c971ca26cd969e593288d6188.png";